import React, { FunctionComponent, useEffect, useState } from 'react';

import { Button, ContentSection, Fieldset, Layout, SectionHeading, Select } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { OutletSearchCombobox } from '../../components/OutletSearchCombobox/OutletSearchCombobox';
import { getSelectedOutlet, saveSelectedOutlet } from '../../services/redux/features/outlet.slice';
import { useNavigate } from '../../services/routing';
import { getOutletDisplayText } from '../../components/Layout/utils';

export const mockOutletList = [
  {
    milesBerCode: '192000',
    milesCompanyId: '10000001',
    milesTradingName: 'Aherns',
    brand: {
      milesBrandId: '400001',
      name: 'VOLKSWAGEN',
    },
  },
  {
    milesBerCode: '193000',
    milesCompanyId: '10000002',
    milesTradingName: 'Blackwater Motors',
    brand: {
      milesBrandId: '400002',
      name: 'AUDI',
    },
  },
  {
    milesBerCode: '194000',
    milesCompanyId: '10000003',
    milesTradingName: 'Divanes',
    brand: {
      milesBrandId: '400003',
      name: 'SEAT',
    },
  },
  {
    milesBerCode: '195000',
    milesCompanyId: '10000004',
    milesTradingName: 'Lavage',
    brand: {
      milesBrandId: '400003',
      name: 'SEAT',
    },
  },
  {
    milesBerCode: '196000',
    milesCompanyId: '10000005',
    milesTradingName: 'Giarge',
    brand: {
      milesBrandId: '400001',
      name: 'VOLKSWAGEN',
    },
  },
  {
    milesBerCode: '197000',
    milesCompanyId: '10000006',
    milesTradingName: 'Liompe',
    brand: {
      milesBrandId: '400002',
      name: 'AUDI',
    },
  },
  {
    milesBerCode: '198000',
    milesCompanyId: '10000007',
    milesTradingName: 'Misame',
    brand: {
      milesBrandId: '400001',
      name: 'VOLKSWAGEN',
    },
  },
] satisfies Array<DealerIntegration.Components.Schemas.MilesBrokerCompaniesData>;

export const OutletPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedOutlet = useSelector(getSelectedOutlet);
  // const { isSuccess, data: outletsList } = useOutletListQuery();
  const [mainHeight, setMainHeight] = useState(undefined as any);
  const [selectedCompany, setSelectedCompany] = useState(selectedOutlet);

  useEffect(() => {
    const getMainHeight = () => document.querySelector<HTMLElement>('.o-main')?.offsetHeight;
    setMainHeight(getMainHeight());
  }, []);

  const handleSubmit = () => {
    dispatch(
      saveSelectedOutlet(mockOutletList.find((company) => company.milesCompanyId === selectedCompany?.milesCompanyId)!)
    );
    navigate.dashboardHome();
  };

  const selectCompany = (companyId: string) => {
    setSelectedCompany(mockOutletList.find((company) => company.milesCompanyId === companyId)!);
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: mainHeight,
      }}
      className="u-mb@s"
    >
      <SectionHeading center level={2} className="u-mb">
        {t('outletPage:title')}
      </SectionHeading>
      <ContentSection className="u-ph-large u-pv-small">
        <Fieldset>
          <Fieldset.Row>
            <Layout center>
              <Layout.Item default="1/3" l="1/2" s="1/1">
                {mockOutletList.length > 6 && (
                  <OutletSearchCombobox
                    allowedCompanies={mockOutletList}
                    onSelectedCompanyChange={selectCompany}
                    selectedCompany={selectedCompany}
                  />
                )}
                {mockOutletList.length <= 6 && (
                  <Select
                    disabled={mockOutletList.length === 1}
                    onChange={(e) => {
                      selectCompany(e.target.value);
                    }}
                    value={selectedCompany?.milesCompanyId}
                  >
                    {mockOutletList.map((company, i) => {
                      const label = getOutletDisplayText(company);
                      const key = `${label} - ${i}`;
                      return (
                        <Select.Item key={key} value={company.milesCompanyId}>
                          {label}
                        </Select.Item>
                      );
                    })}
                  </Select>
                )}
              </Layout.Item>
            </Layout>
          </Fieldset.Row>
          <Fieldset.Row className="u-text-center u-mt-small">
            <Layout center>
              <Button id="login" testId="login" type="button" onClick={handleSubmit}>
                {t('outletPage:nextButton')}
              </Button>{' '}
            </Layout>
          </Fieldset.Row>
        </Fieldset>
      </ContentSection>
    </div>
  );
};
